__turbopack_context__.v({
  "legend": "DmuRyG_legend",
  "legend-item": "DmuRyG_legend-item",
  "line-indicator": "DmuRyG_line-indicator",
});
